import { Screen } from '@betty/navigation';
import { ScrollView } from 'react-native';
import ContactUsForm from '../components/ContactUsForm/ContactUsForm';

function ContactUsScreen() {
  return (
    <Screen>
      <ScrollView>
        <ContactUsForm />
      </ScrollView>
    </Screen>
  );
}

export default ContactUsScreen;
